import { start } from "single-spa";
import { buildLayoutEngine } from "./utils/layoutEngineBuilder";
import { LayoutEngine } from "single-spa-layout/dist/types/browser/constructLayoutEngine";
import packageInfo from "../package.json";

export const configureRootConfig = async (logger) => {
  try {
    if (!global.MFEConfigs) {
      throw new Error("Error, no global MFEConfigs defined");
    }
    const layoutEngine: LayoutEngine = await buildLayoutEngine(
      global.MFEConfigs
    );

    if (!layoutEngine) {
      throw new Error("Error, no layoutEngine defined");
    }
    layoutEngine.activate();
    start();
  } catch (err) {
    if (window.dtrum) {
      window.dtrum.reportError(
        `Error in ${packageInfo.name}@${packageInfo.version}: \n${err.stack}`
      );
    }

    // This is the kind of error where we can't even render an index page
    logger.log(
      "There has been an error at the top level in root-config, this is unrecoverable. Please check you have configured this brand correctly. ",
      JSON.stringify(err.message)
    );
  }
};

configureRootConfig(console);
